import { baseCheckSliderMinMaxProps, checkSliderStepProperty } from "../Slider/helpers";
var COMPONENT_NAME = 'CompactSlider';
export var checkCompactSliderProps = function (_a) {
    var startValue = _a.startValue, minLimit = _a.minLimit, maxLimit = _a.maxLimit, endValue = _a.endValue, step = _a.step;
    baseCheckSliderMinMaxProps({ min: minLimit, max: maxLimit, componentName: COMPONENT_NAME });
    if (minLimit < startValue) {
        throw new Error(COMPONENT_NAME + " error: the argument \"min\" must be greater than or equal than \"startValue\".");
    }
    if (maxLimit > endValue) {
        throw new Error(COMPONENT_NAME + " error: the argument \"max\" must be smaller than or equal than \"endValue\".");
    }
    checkSliderStepProperty({ min: minLimit, max: maxLimit, step: step, componentName: COMPONENT_NAME });
};
export var getCompactSliderValue = function (internalPercentValue, startValue, minMaxLength) { return Math.round(startValue + (internalPercentValue * minMaxLength) / 100); };
//# sourceMappingURL=helpers.js.map